import FormikAutoComplete from "common/components/FormikFields/FormikAutoComplete"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import { DEFAULT_COUNTRY_SELECTED, countries } from "common/constants/countries"
import useRazonSocialAndCif from "common/hooks/useRazonSocialAndCif"
import useSearchEmpresa from "common/hooks/useSearchEmpresa"
import ReactFlagsSelect from "react-flags-select"
import { useTranslation } from "react-i18next"

const DatosClienteForm = ({ setFieldValue, values }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { searchEmpresaByNif } = useSearchEmpresa({})

  const {
    razonesSociales,
    cifs,
    getByCifOrRazonSocial,
    getRazonSocialByCif,
    getCifByRazonSocial,
    getEmpresaIDByCif,
    getEmpresaIDByRazonSocial,
  } = useRazonSocialAndCif()

  const handleOnSelectRazonSocial = async (e: $TSMigrationFixMe) => {
    const cif = getCifByRazonSocial(e.value)
    const id = getEmpresaIDByRazonSocial(e.value)

    setFieldValue("libradoRazonSocial", e.value)
    setFieldValue("libradoNif", cif)
    setFieldValue("libradoID", id)
    searchEmpresaByNif(cif)
  }

  const handleOnSelectCif = (e: $TSMigrationFixMe) => {
    setTimeout(() => setFieldValue("libradoNif", e.value), 10) // TODO: Revisar porque existe el setTimeout
    const razonSocial = getRazonSocialByCif(e.value)
    const id = getEmpresaIDByCif(e.value)

    setFieldValue("libradoRazonSocial", razonSocial)
    setFieldValue("libradoID", id)
    searchEmpresaByNif(e.value)
  }

  return (
    <>
      <div className='text-left p-fluid p-formgrid p-grid'>
        <div className='p-field p-col'>
          <label htmlFor='nombreLibrado'>{t("ocr.nameLabel")}</label>

          {values.libradoPais === DEFAULT_COUNTRY_SELECTED ? (
            <FormikAutoComplete
              id='nombreLibrado'
              name='libradoRazonSocial'
              completeMethod={(query: $TSMigrationFixMe) =>
                getByCifOrRazonSocial("razonSocial", query)
              }
              suggestions={razonesSociales}
              onSelect={handleOnSelectRazonSocial}
              onChange={handleOnSelectRazonSocial}
            />
          ) : (
            <FormikInputText
              id='nombreLibrado'
              name='libradoRazonSocial'
            />
          )}
        </div>

        <div className='p-field p-col selected-country-mix-cif'>
          <label htmlFor='libradoNif'>{t("ocr.nifLabel")}</label>

          <ReactFlagsSelect
            name='libradoPais'
            className='selected-country-mix-cif__select-country-field'
            onSelect={(code) => setFieldValue("libradoPais", code)}
            searchable
            selected={values.libradoPais || DEFAULT_COUNTRY_SELECTED}
            customLabels={countries}
            // @ts-expect-error TS(2322): Type 'DefaultTFuncReturn' is not assignable to typ...
            searchPlaceholder={t("ocr.placeholderSearch")}
            showSelectedLabel={false}
          />

          <FormikAutoComplete
            id='libradoNif'
            name='libradoNif'
            isCif
            className='selected-country-mix-cif__input-cif-field'
            completeMethod={(query: $TSMigrationFixMe) =>
              getByCifOrRazonSocial("cif", query)
            }
            suggestions={cifs}
            onSelect={handleOnSelectCif}
            onChange={handleOnSelectCif}
          />
        </div>
      </div>

      {/* TODO: Averiguar para exite el input oculto */}
      <input
        type='text'
        autoComplete='on'
        value=''
        style={{
          display: "none",
          opacity: 0,
          position: "absolute",
          left: "-100000px",
        }}
        readOnly
      />
    </>
  )
}

export default DatosClienteForm
